export const CREATE_BUSINESS_PROFILE = "Create a business profile first";
export const MIN_COINS_TO_WITHDRAW = 1000